import React, { Fragment, useRef, useState } from 'react';
import moment from 'moment';
import { orderBy } from 'lodash';
import { addOOPTimeLabel, getMatchDraw } from '../../../utils/events';

import TabBar from '../../TabBar';
import Court from './Court';

const _ = { orderBy };

const OrderOfPlayGrid = ({ draws, orderOfPlay = {}, locations = [], playersDict, facilityId, date, timeZone, ...restProps }) => {
    const tabBarRef = useRef(null);

    const [activeCourtIndex, setActiveCourtIndex] = useState(0);

    const handleDrawsTabClick = (ev, i) => {
        setActiveCourtIndex(i);
    };

    const allEventMatches = draws.reduce((acc, draw) => {
        draw.rounds.forEach(round => {
            round.matches.forEach(match => {
                acc.push(match);
            });
        });
        if (draw.childDraws) {
            draw.childDraws.forEach(childDraw => {
                childDraw.rounds.forEach(round => {
                    round.matches.forEach(match => {
                        acc.push(match);
                    });
                });
            });
        }
        return acc;
    }, []);

    const facilities = [];
    (locations || []).forEach(location => {
        // eslint-disable-next-line no-unused-expressions
        location.facilities?.forEach(facility => {
            if (facility.courts.some(c => c.enabled)) {
                facility.courts.forEach(c => {
                    c.matches = [];
                });
                facilities.push(facility);
            }
        });
    });

    const facilityIndex = facilities.findIndex(f => f.id === facilityId);

    (orderOfPlay || []).forEach(oopObj => {
        const facility = facilities.find(f => f.id === oopObj.facilityId);
        if (facility) {
            const court = facility.courts.find(c => c.id === oopObj.courtId);
            if (court) {
                court.matches = court.matches || [];
                const match = allEventMatches.find(m => {
                    return m.id === oopObj.matchId && moment(moment(date).format('YYYY-MM-DD')).isSame(moment.utc(m.date).tz(timeZone.value).format('YYYY-MM-DD'), 'day');
                });
                if (match) {
                    const matchDraw = getMatchDraw(match, draws);
                    if (matchDraw?.published === true) {
                        court.matches.push({
                            ...match,
                            includesTime: oopObj.includesTime,
                            notBefore: oopObj.notBefore,
                            sequenceNumber: oopObj.sequenceNumber,
                        });
                    }
                }
            }
        }
    });
    facilities.forEach(facility => {
        facility.courts.forEach(court => {
            court.matches = _.orderBy(court.matches, ['sequenceNumber']);
            court.matches = addOOPTimeLabel(court.matches, timeZone);
            if (court.matches.length) {
                court.hasMatches = true;
            }
        });
        if (facility.courts.some(c => c.hasMatches && c.enabled)) {
            facility.hasMatches = true;
        }
    });

    const getCourts = () => {
        if (facilities[facilityIndex]?.courts) {
            return _.orderBy(facilities[facilityIndex].courts.filter(c => c.enabled && c.hasMatches), [c => c.name?.toLowerCase()]);
        }
        return [];
    };

    return (
        <Fragment>
            <TabBar
                tabs={getCourts().map((court, i) => ({
                    title: court.name,
                    titleName: court.name,
                    showTab: true,
                    active: activeCourtIndex === i,
                }))}
                handleTabClick={handleDrawsTabClick}
                data-testid="event-profile.schedule-legacy.courts-tab-bar"
                ref={tabBarRef}
                eventName="Draws Tab Clicked"
                transparent={true}
                noContainer={true}
                clickCategory="Event Profile"
                clickLocation="Schedule Tab - OOP Court Tabs"
            />
            <div className={`container bg-transparent matches`}>
                <div className="row">
                    {getCourts().map((court, i) => {
                        if (i >= activeCourtIndex && i <= activeCourtIndex + 2) {
                            return (
                                <Court
                                    court={court}
                                    columnNumber={i + 1}
                                    playersDict={playersDict}
                                    draws={draws}
                                    timeZone={timeZone}
                                    {...restProps}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </Fragment>
    );
};

export default OrderOfPlayGrid;
